import { gql } from "@apollo/client";
import { fetchMutation } from "../../../actions";
import { setSubscriptionInterval } from "../../../redux/actions/auth.action";
import { store } from "../../../redux/store";
import { showSwalPopup } from "../../notes/actions/ShowSwalPopup";

export const CREATE_PAYMENT = gql`
   mutation CreatePaymentSession($createPaymentSession: createPaymentSessionInput) {
      createPaymentSession(createPaymentSession: $createPaymentSession) {
         sessionId
         url
         status {
            code
            success
            message
         }
      }
   }
`;

export const UPDATE_STRIPE = gql`
   mutation UpdateProfile($user: UserInput) {
      updateProfile(user: $user) {
         status {
            code
            message
            success
         }
         user {
            extendTrial
            isTrialUser
            trialRemaining
            isSubscribed
         }
      }
   }
`;

export const MANAGE_SUBSCRIPTION = gql`
   query GetSubscriptionManagementLink {
      getSubscriptionManagementLink {
         url
      }
   }
`;

export const GET_SUBSCRIPTION_PLAN = gql`
   query GetSubscriptionPlanList {
      getSubscriptionPlanList {
         plans {
            amount
            currency
            interval
            priceId
         }
         status {
            code
            message
            success
         }
      }
   }
`;
export const startPaymentSession = (subscriptionInterval) => {
   store.dispatch(setSubscriptionInterval(subscriptionInterval));
   const obj = {
      createPaymentSession: {
         priceId: subscriptionInterval?.priceId,
      },
   };
   fetchMutation(
      CREATE_PAYMENT,
      obj,
      (res) => {
         const paymentLink = res?.data?.createPaymentSession?.url;
         const alreadySubscribedMess = res?.data?.createPaymentSession?.status?.message || "";
         const SubscribedMess = "you have already subscribed.";
         const isAlreadySubscribed = alreadySubscribedMess.toLowerCase() === SubscribedMess;
         if (isAlreadySubscribed) {
            showSwalPopup(
               `Already Subscribed`,
               `You have already subscribed. Please go to the home page.`,
               "Okay",
               "Okay",
               "",
               () => {
                  window.location.href = "/notes";
               },
               () => {},
               false,
               true,
               true
            );
            return;
         }
         if (paymentLink) {
            window.location.href = paymentLink;
         }
      },
      (error) => {
         console.error("Error creating Stripe payment session:", error);
      }
   );
};

export const findYearlyAmountFun = (price) => {
   const yearlyAmount = parseInt(
      String(price)
         .match(/[\d,]+/)?.[0]
         ?.replace(/,/g, "") || "0",
      10
   );
   return yearlyAmount;
};
